import React, { useEffect, useState } from 'react';
import gravatar from 'gravatar';
import './UserIcon.scss';
import { apimCall } from '../helpers/api';
import { GoFormzServices } from '../AppSettings';

export interface UserIconProps {
  emailAddress: string;
  firstName: string;
  lastName: string;
  userId: string;
  hasProfilePicture: boolean;
  light?: boolean;
  square?: boolean;
}

export default function UserIcon(props: UserIconProps) {
  const [avatarUrl, setAvatarUrl] = useState<string>();

  useEffect(() => {
    setAvatarUrl('');
    if (props.hasProfilePicture) {
      getProfilePictureUrl(props.userId).then((profilePictureUrl) => {
        setAvatarUrl(profilePictureUrl);
      });
    } else {
      const gravatarUrl = gravatar.url(props.emailAddress, { d: '404' });

      const avatarImage = new Image();
      avatarImage.onload = () => {
        setAvatarUrl(gravatarUrl);
      };
      avatarImage.src = gravatarUrl;
    }
  }, [props.emailAddress, props.hasProfilePicture, props.userId]);

  return (
    <div className={`user-icon${props.light ? ' light' : ''} ${props.square ? 'square' : 'round'}`}>
      {avatarUrl ? (
        <img src={avatarUrl} />
      ) : (
        <div className="initials">
          <svg width="100%" height="100%" viewBox="0 0 80 80" preserveAspectRatio="xMinYMin meet">
            <foreignObject width="100%" height="100%" xmlns="http://www.w3.org/1999/xhtml">
              <div>{`${props.firstName ? props.firstName.charAt(0).toUpperCase() : ''}${props.lastName ? props.lastName.charAt(0).toUpperCase() : ''}`}</div>
            </foreignObject>
          </svg>
        </div>
      )}
    </div>
  );
}

type ProfilePicturesResult = {
  baseUrl: string;
  signature: string;
  expiration: string;
};

let getProfilePictureSasPromise = null;
let getProfilePictureSasResult: ProfilePicturesResult = null;

function getProfilePictureSas(): Promise<ProfilePicturesResult> {
  if (getProfilePictureSasResult) {
    return Promise.resolve(getProfilePictureSasResult);
  }

  if (getProfilePictureSasPromise === null) {
    getProfilePictureSasPromise = apimCall<ProfilePicturesResult>(GoFormzServices.AccountService, '/profile/profilepictures').then((response) => {
      getProfilePictureSasResult = response.data;
    });
  }

  return getProfilePictureSasPromise.then(() => {
    getProfilePictureSasPromise = null;
    return getProfilePictureSasResult;
  });
}

export async function getProfilePictureUrl(userId: string) {
  const profilePicturesResult = await getProfilePictureSas();
  return `${profilePicturesResult.baseUrl}/profilepictures/${userId}${profilePicturesResult.signature}`;
}
